import React, { useRef, useEffect, useMemo, useState } from 'react';
import filter from '../assets/images/filter.png';
import { useTranslation } from 'react-i18next';

const DateTimeSelector = ({
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  modalIsOpen2,
  handleMonthChange,
  handleDayChange,
  handleDayClick,
  handleHourClick,
  daysToShow,
  hours,
  totalPrice,
  scrollLeft,
  scrollRight,
  openModal,
  getMonthName,
  selectedDateScroll,
  getDayName,
  getFilterText,
  handleResetFilter,
  unavailableDates,
  availableHours,
  buffertime,
  totalDuration,
  currentTherapist,
  isEditMode = false,
  isHotel = true
}) => {
  const { t } = useTranslation('therapist');

  const hoursContainerRef = useRef(null);

  const firstAvailableHour = useMemo(() => {
    return Object.entries(availableHours).find(([hour, available]) => {
      const isSunday = selectedDate && selectedDate.getDay && !isNaN(selectedDate.getTime()) && selectedDate.getDay() === 0;
      return available && !(!isHotel && isSunday);
    })?.[0];
  }, [availableHours, selectedDate, isHotel]);


  useEffect(() => {
    if (hoursContainerRef.current && (selectedTime || firstAvailableHour)) {
      const targetHour = selectedTime || firstAvailableHour;
      const hourElements = hoursContainerRef.current.querySelectorAll('.btn-hour');
      const hourIndex = Object.keys(availableHours).indexOf(targetHour);

      if (hourIndex >= 0 && hourElements[hourIndex]) {
        const container = hoursContainerRef.current;
        const element = hourElements[hourIndex];
        const containerWidth = container.offsetWidth;
        const elementLeft = element.offsetLeft;
        const elementWidth = element.offsetWidth;

        container.scrollTo({
          left: elementLeft - (containerWidth) + (elementWidth / 4),
          behavior: 'smooth'
        });
      }
    }
  }, [selectedTime, firstAvailableHour]);

  const isHourAvailable = (hour, index) => {
    const now = new Date();
    const isToday = selectedDate?.toDateString() === now.toDateString();

    return availableHours?.some(({ start_time, end_time }) => {
      const [hourHours, hourMinutes] = hour.split(':').map(Number);
      const hourValue = hourHours * 100 + hourMinutes;

      const [startHours, startMinutes] = start_time.split(':').map(Number);
      let startValue = startHours * 100 + startMinutes + Number(buffertime.bufferBefore);

      if (index == 0) {
        if (isToday && hour !== start_time) {

          const requiredBufferStart = hourValue + Number(buffertime.bufferBefore);
          if (hourValue < requiredBufferStart) {
            return false;
          }
        }
      }

      const [endHours, endMinutes] = end_time.split(':').map(Number);
      const endValue = endHours * 100 + endMinutes - Number(buffertime.bufferAfter) - 40 - totalDuration - 40;
      return hourValue >= startValue && hourValue <= endValue;
    });
  };
  const safeSelectedDate = selectedDateScroll || selectedDate;
  
  return (
    <div>
      <div className={`form-group group-mois ${modalIsOpen2 && "group-mois-padding"}`}>
        {/* {!modalIsOpen2 &&
          <label>Mois</label>
        } */}
        <div className="btn-group" role="group">
          <button type="button" className="btn-slide btn-prev" onClick={() => handleMonthChange(-1)}>
            &lt;
          </button>
          <span className="text-month"> {getMonthName(safeSelectedDate)}</span>
          <button type="button" className="btn-slide btn-next btn-month" onClick={() => handleMonthChange(1)}>
            &gt;
          </button>
        </div>
      </div>
      <div className="form-group group-jour modal-therapist">
        {/* {!modalIsOpen2 &&
        <label>Jour</label>} */}
        <div className="btn-group" role="group">
          <button type="button" className="btn-slide btn-prev" onClick={() => handleDayChange(-1)}>
            &lt;
          </button>
          <div className="row-date">
            {daysToShow.map((date) => {
              if (!date || isNaN(date.getTime())) {
                return null;
              }
              const isUnavailable = unavailableDates?.includes(date.toDateString());
              return (
                <button
                  key={date.getTime()}
                  type="button"
                  className={`btn-day ${!isUnavailable ? 'disabled' : ''} ${date?.toDateString() === selectedDate?.toDateString() ? 'selected' : ''
                    }`}
                  onClick={() => isUnavailable && handleDayClick(date)}
                  disabled={!isUnavailable}
                >
                  {`${getDayName(date)}`} <br /> <span>{`${date.getDate()}`}</span>
                  <br /> {`${!isUnavailable ? t('epuise') : ''}`}
                </button>
              )

            })}
          </div>
          <button type="button" className="btn-slide btn-next btn-month" onClick={() => handleDayChange(1)}>
            &gt;
          </button>
        </div>
      </div>
      <div className="form-group group-heure modal-therapist">

        {/* <label>{!modalIsOpen2 ? 'Heure' : 'Durée'}</label> */}
        {selectedDate ? ( 
        <div className="btn-group" role="group">
          <button type="button" className="btn-slide btn-prev" onClick={scrollLeft}>
            &lt;
          </button>
          <div className="row-day" ref={hoursContainerRef}>
            {(!availableHours || (Array.isArray(availableHours) && availableHours.length === 0) || (!Array.isArray(availableHours) && Object.keys(availableHours).length === 0)) ? (
              <div className="fully-booked-message">
                {t(selectedDate ? 'loading_slots' : 'no_selected_slots')}
              </div>
            ) : Array.isArray(availableHours) ? (
              // Handle array format (fallback hours)
              availableHours.map((hour) => {
                const isSunday = selectedDate && selectedDate.getDay && !isNaN(selectedDate.getTime()) && selectedDate.getDay() === 0;
                const isFirstAvailable = hour === firstAvailableHour;
                const shouldSelect = selectedTime === hour || (!selectedTime && isFirstAvailable);

                return (
                  <button
                    type="button"
                    key={hour}
                    className={`btn-hour ${(!isHotel && isSunday) ? 'disabled' : ''
                      } ${selectedTime === hour || (!isHotel && isSunday)
                        ? 'selected'
                        : 'btn-outline-primary'
                      }`}
                    onClick={() => handleHourClick(hour)}
                    disabled={!isHotel && isSunday}
                  >
                    {hour} <br />
                    <span>{totalPrice}&nbsp;chf</span>
                    <br />
                    {`${(!isHotel && isSunday) ? 'Hotel' : ' '}`}
                  </button>
                );
              })
            ) : Object.entries(availableHours).every(([_, available]) => !available) ? (
              <div className="fully-booked-message">
                {t(isEditMode || currentTherapist ? 'fully_booked_message_single' : 'fully_booked_message')}
              </div>
            ) : (
              // Handle object format (API response)
              Object.entries(availableHours).map(([hour, available]) => {
                const isSunday = selectedDate && selectedDate.getDay && !isNaN(selectedDate.getTime()) && selectedDate.getDay() === 0;
                const isFirstAvailable = hour === firstAvailableHour;
                const shouldSelect = selectedTime === hour || (!selectedTime && isFirstAvailable);

                return (
                  <button
                    type="button"
                    key={hour}
                    className={`btn-hour ${!available || (!isHotel && isSunday) ? 'disabled' : ''
                      } ${selectedTime === hour || (!isHotel && isSunday)
                        ? 'selected'
                        : 'btn-outline-primary'
                      }`}
                    onClick={() => available && handleHourClick(hour)}
                    disabled={!available}
                  >
                    {hour} <br />
                    <span>{totalPrice}&nbsp;chf</span>
                    <br />
                    {`${!available && (isHotel || !isSunday) ? t('epuise') : (!isHotel && isSunday) ? 'Hotel' : ' '}`}
                  </button>
                );
              })
            )}
          </div>

          <button type="button" className="btn-slide btn-next btn-month" onClick={scrollRight}>
            &gt;
          </button>
        </div>
        ) : (
          ''
          )}
        {!modalIsOpen2 && window.location.pathname !== "/flypro-booking" && !isEditMode &&
          <>
            {selectedTime ?
              <>
                <div className='filter-txt'>
                  <a href="#0" className="filter-user" onClick={openModal}>
                    {t('filter_preferences')}
                    <img className='filter-pref' src={filter} alt="Supprimer" />
                  </a>
                  <p>
                    {getFilterText}
                    {getFilterText && <button className='reset-filter' type='button' onClick={() => handleResetFilter()}>X</button>}
                  </p>
                </div>
                <p style={{ textAlign: "center", fontWeight: 700 }}> {t('select_therapist')}</p>
              </> :
              <p style={{ textAlign: "center", fontWeight: 700, marginTop: "40px" }}> {t('select_therapist_zone')}</p>
            }
          </>
        }
      </div>
    </div >
  );
};

export default DateTimeSelector;